import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Statistic,
	Modal,
	Tooltip,
} from "antd";
import { CustomTable } from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	EditOutlined,
	FilePdfOutlined,
	MailOutlined,
	PlusCircleFilled,
	RetweetOutlined,
} from "@ant-design/icons";
import QAQCBreakDayModal from "./QAQCBreakDayModal";
import QAQCTestingLoadModal from "./QAQCTestingLoadModal";
import QAQCSendInternalPDF from "./QAQCSendInternalPDF";
const { Text, Title } = Typography;

const QAQCJobLoadsInternalModal = ({
	modalOpenLoads,
	setModalOpenLoads,
	selectedJob,
	setSelectedJob,
	history,
}) => {
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadList, setLoadList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const [refresh, setRefresh] = useState(false);

	const [openModalSend, setOpenModalSend] = useState(false);
	const [modalOpenBreakDay, setModalOpenBreakDay] = useState(false);
	const [modalOpenTestingLoad, setModalOpenTestingLoad] = useState(false);

	const [selectedLoad, setSelectedLoad] = useState(null);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columnsLoads = [
		{
			title: "Delivery Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load (YD3)",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Sample Type and Size",
			dataIndex: "pourTestingCylinderSize",
			key: "pourTestingCylinderSize",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Specimens ID",
			dataIndex: "specimensIDS",
			key: "specimensIDS",
			render: (values) => {
				return (
					<Flex vertical gap={16}>
						{values.map((item, index) => (
							<Text key={index}>{item}</Text>
						))}
					</Flex>
				);
			},
		},
		{
			title: "Break Day Age",
			dataIndex: "breakDayAge",
			key: "breakDayAge",
			render: (values, record) => {
				return (
					<Flex gap={16} align="end">
						<Flex vertical gap={16}>
							{values.map((item, index) => (
								<Text key={index}>{item.age}</Text>
							))}
						</Flex>
						<Button
							icon={<EditOutlined />}
							type="primary"
							onClick={() => {
								setModalOpenBreakDay(true);
								setSelectedLoad(record);
							}}
						/>
					</Flex>
				);
			},
		},
		{
			title: "Test Date",
			dataIndex: "testDate",
			key: "testDate",
			render: (values) => {
				return (
					<Flex vertical gap={16}>
						{values.map((item, index) => (
							<Text key={index}>{dayjs(item.date).format("MM/DD/YYYY")}</Text>
						))}
					</Flex>
				);
			},
		},
		{
			title: "Specimen Area [in2]",
			dataIndex: "specimenArea",
			key: "specimenArea",
			render: (value, record) => {
				const array = Array.from(
					{ length: record.pourTestingCylinders },
					(_, i) => value,
				);
				return (
					<Flex vertical gap={16}>
						{array.map((item, index) => (
							<Text key={index}>{item}</Text>
						))}
					</Flex>
				);
			},
		},
		{
			title: "Testing Max Load [lbs]",
			dataIndex: "testingMaxLoad",
			key: "testingMaxLoad",
			render: (values, record) => {
				return (
					<Flex gap={16} align="end">
						<Flex vertical gap={16}>
							{values.map((item, index) => (
								<Text key={index}>{item.maxLoad}</Text>
							))}
						</Flex>
						<Button
							icon={<EditOutlined />}
							type="primary"
							onClick={() => {
								setModalOpenTestingLoad(true);
								setSelectedLoad(record);
							}}
						/>
					</Flex>
				);
			},
		},
		{
			title: "Strength [psi]",
			dataIndex: "strength",
			key: "strength",
			render: (values) => {
				return (
					<Flex vertical gap={16}>
						{values.map((item, index) => (
							<Text key={index}>{item.strength}</Text>
						))}
					</Flex>
				);
			},
		},
		{
			title: "Percent of Design",
			dataIndex: "percentOfDesign",
			key: "percentOfDesign",
			render: (values) => {
				return (
					<Flex vertical gap={16}>
						{values.map((item, index) => (
							<Text key={index}>{item.percent}</Text>
						))}
					</Flex>
				);
			},
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (value, record) => {
				return (
					<Flex gap={10}>
						<Tooltip title="Generate PDF">
							<Button
								icon={<FilePdfOutlined />}
								type="primary"
								onClick={() => {
									history.push(
										`/qc/job/load/laboratory/internal/pdf/${record.id}`,
									);
								}}
							/>
						</Tooltip>
						<Tooltip title="Send Email">
							<Button
								type="primary"
								icon={<MailOutlined />}
								onClick={() => {
									setSelectedLoad(record);
									setOpenModalSend(true);
								}}
							/>
						</Tooltip>
						{record.specimensIDS.length === 0 && (
							<Tooltip title="Add Specimens ID">
								<Button
									type="primary"
									danger
									icon={<PlusCircleFilled />}
									onClick={() => {
										generateSpecimensID(record);
									}}
								/>
							</Tooltip>
						)}
					</Flex>
				);
			},
		},
	];

	const generateSpecimensID = async (load) => {
		try {
			setLoadingTable(true);
			const url = api + `/job/update/qc/load/specimensID/${load.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url);
			if (data.success) {
				openNotification("success", "Updated", data.message);
				setTimeout(() => {
					setLoadingTable(false);
					setRefresh((prev) => !prev);
				}, 2000);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	useEffect(() => {
		if (selectedJob) getLoadList();
	}, [refresh, selectedJob]);

	const getLoadList = async () => {
		try {
			setLoadingTable(true);
			const url = api + `/job/get/qc/laboratory/loads/${selectedJob.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						deliveryTicket: item.deliveryTicket,
						truck: item.truck.number,
						yards: item.yards,
						pourTestingCylinderSize: item.qcData.pourTestingCylinderSize,
						specimensIDS: item.qcData.specimensIDS || [],
						pourTestingCylinders: item.qcData.pourTestingCylinders || [],
						specimenArea: item.qcData.specimenArea,
						breakDayAge: item.qcData.breakDayAge || [],
						testDate: item.qcData.testDate || [],
						testingMaxLoad: item.qcData.testingMaxLoad || [],
						strength: item.qcData.strength,
						percentOfDesign: item.qcData.percentOfDesign || [],
					});
				});
				setLoadList(list);
				setLoadingTable(false);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	return (
		<Modal
			title={`Job ID: ${selectedJob?.number}`}
			open={modalOpenLoads}
			onCancel={() => {
				setSelectedJob(null);
				setModalOpenLoads(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			<Flex vertical gap={16}>
				<Title level={4}>Registered Samples</Title>
				<Button
					type="primary"
					onClick={() => setRefresh((prev) => !prev)}
					icon={<RetweetOutlined />}
					size="large"
					loading={loadingTable}
				/>
				<CustomTable
					columns={columnsLoads}
					data={loadList}
					loading={loadingTable}
				/>
			</Flex>
			{contextHolder}
			<QAQCBreakDayModal
				modalOpenBreakDay={modalOpenBreakDay}
				setModalOpenBreakDay={setModalOpenBreakDay}
				selectedLoad={selectedLoad}
				setSelectedLoad={setSelectedLoad}
				setRefresh={setRefresh}
			/>
			<QAQCTestingLoadModal
				modalOpenTestingLoad={modalOpenTestingLoad}
				setModalOpenTestingLoad={setModalOpenTestingLoad}
				selectedLoad={selectedLoad}
				setSelectedLoad={setSelectedLoad}
				setRefresh={setRefresh}
			/>
			<QAQCSendInternalPDF
				openModalSend={openModalSend}
				setOpenModalSend={setOpenModalSend}
				selectedLoad={selectedLoad}
			/>
		</Modal>
	);
};

export default QAQCJobLoadsInternalModal;
